module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAN0lEQVQ4T2NkwAGCp3/fD5Jam8npiE0J46hGPIEDCz30QPrPwKgPEmNk+H8Ra6iSrXE0OmiQVgHJbztPMsDOFgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/addclass.png
// module id = nO9/
// module chunks = 96